import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=35b628b5&scoped=true"
import script from "./plan.vue?vue&type=script&lang=ts"
export * from "./plan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b628b5",
  null
  
)

export default component.exports